/* eslint-disable react/jsx-no-undef */
import React, { Component } from "react";
import Grid from "@material-ui/core/Grid/Grid";
import style from "./style";
import Avatar from "@material-ui/core/Avatar/Avatar";
import Card from "@material-ui/core/Card/Card";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import TextField from "@material-ui/core/TextField/TextField";
import Checked from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import {client} from "../../config/apollo";
import {GET_CHEF_DETAILS} from "../../graphql/queries/chef";
import {SET_CHEF_DETAILS} from "../../redux/stateConstants";

const DataItem = props => (
  <ListItem divider={props.checked} style={style.listItemStyle}>
    <div>
      <p style={style.label}>{props.label}</p>
    </div>
    <div>
      {props.checked ? (
        <Checked style={{ color: "#4caf50" }} />
      ) : (
        <Clear style={{ color: "#f34016" }} />
      )}
    </div>
  </ListItem>
);
class DinersKitchen extends Component {

    render() {
    const { booking,userDetails: { userProfile } } = this.props;
    let address = null;
    if (booking.address) address = booking.address;
    else address = userProfile.address;
    let add=!!address && !!booking && booking.status=='ACCEPTED' ? `${address.street1} ${address.street2 ? address.street2 : '' }, ${address.city}, ${address.state}, ${address.zip}, ${address.country ? address.country : 'US'}`:`${address.city}, ${address.state}, ${address.zip}, ${address.country ? address.country : 'US'}`;
    return (
      <Grid container className="custom-review-container">
          <Grid
          data-test-id={"dinerlocbkg"}

          item md={12}>
              <p style={style.headingText}>Diner location</p>
              <p style={style.subHeadingText}>
                  {!!address && address.city ? add:''}
              </p>
          </Grid>
        <Grid item md={12} style={{ marginTop: 50 }}>
          <p style={style.headingText}>Diner’s kitchen</p>
        </Grid>
        <Grid item md={12}>
          <p className="margin-0" style={style.subHeadingText}>
            This is what the diner’s kitchen has in store.
          </p>
        </Grid>

        {!!booking.equipmentsPresent.length && booking.equipmentsPresent.length > 0 ? <Grid
	     data-test-id={"kitchenlist"}
	    item md={12}>

          <ListItem style={style.listItemStyle}>
            <div>
              <p style={style.listHeading}>Items present</p>
            </div>
          </ListItem>
          {booking.equipmentsPresent &&
            !!booking.equipmentsPresent.length &&
            booking.equipmentsPresent.map((equipment, index) => (
              <DataItem
                key={index + "eqipp"}
                label={equipment}
                checked={true}
              />
            ))}
        </Grid> : <Grid item md={12}>
          <p style={style.subHeadingText}>
            No information available on diner's kitchen.
          </p>
        </Grid>}
      </Grid>
    );
  }
}

export default DinersKitchen;
